import { FC, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { RequireAuth } from "./utils/RequireAuth";
import "./App.css";
import { Toaster } from "react-hot-toast";
import { TOASTER_PROPS } from "./lib";
import { lazyWithRetry } from "./utils/lazyWithRetry";
// import Main from "./components/main/Main";
import { DndProvider } from "react-dnd-multi-backend";
import { HTML5toTouch } from "rdndmb-html5-to-touch";
//import HTML5Backend from "react-dnd-html5-backend";
//import  TouchBackend  from "react-dnd-touch-backend";
//import  MultiBackend, { TouchTransition, MouseTransition } from "react-dnd-multi-backend";

const Home = lazyWithRetry(() => import("./components/home/Home"));
const Document = lazyWithRetry(() => import("./components/document/Document"));
const Main = lazyWithRetry(() => import("./components/main/Main"));
const Container = lazyWithRetry(()  => import("./components/administrative/Container"))
const Dashboard = lazyWithRetry(()  => import("./components/administrative/Dashboard"))
const Team = lazyWithRetry(()  => import("./components/administrative/Team"))
const RetrieveDocument = lazyWithRetry(
  () => import("./components/retrieveDocument/RetrieveDocument")
);
const AddDcoument = lazyWithRetry(() => import("./components/addDocument/AddDocument"));
const Completed = lazyWithRetry(() => import("./components/sentdocument/Completed"));
const EditDocument = lazyWithRetry(
  () => import("./components/editDocument/EditDocument")
);
const Expiring = lazyWithRetry(() => import("./components/sentdocument/Expiring"));
const Login = lazyWithRetry(() => import("./components/login/Login"));
const Pending = lazyWithRetry(() => import("./components/sentdocument/Pending"));
const Register = lazyWithRetry(() => import("./components/register/Register"));
const Settings = lazyWithRetry(() => import("./components/settings/Settings"));
const Template = lazyWithRetry(() => import("./components/template/Template"));
const Subscription = lazyWithRetry(
  () => import("./components/subscription/Subscription")
);
const HelpDesk = lazyWithRetry(() => import("./components/helpDesk/HelpDesk"));
const ResetPassword = lazyWithRetry(() => import("./components/reset-password/ResetPassword"));
const ForgotPassword = lazyWithRetry(() => import("./components/forgot-password/ForgotPassword"));

const App: FC = () => {
  /**
   const CustomHTML5toTouch: MultiBackendOptions = {
    backends: [
      {
        id: "html5",
        backend: HTML5Backend as any ,
        transition: MouseTransition
      },
      {
        id: "touch",
        backend: TouchBackend as any,
        options: { enableMouseEvents: true },
        preview: true,
        transition: TouchTransition,
        skipDispatchOnTransition: true
      }
    ]
  };
 */

  return (
    <div className="App w-full h-full   text-[13px] sm:text-sm">
      <Toaster {...TOASTER_PROPS} />

      <Router>
        <Suspense
          fallback={
            <div className="w-full h-full inset-0 fixed ">
              <div className="w-fit h-fit m-auto absolute inset-0">
                <div className="border-l-2 border-b-2 animate-spin rounded-full border-donkeysign h-12 w-12 "></div>
              </div>
            </div>
          }
        >
          <DndProvider options={HTML5toTouch}>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route element={<Main />}>
                <Route path="/home" element={<Home />} />
                <Route path="/document" element={<Document />} />
                <Route path="/template" element={<Template />} />
                <Route path="/completed" element={<Completed />} />
                <Route path="/expiring" element={<Expiring />} />
                <Route path="/pending" element={<Pending />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/help-desk" element={<HelpDesk />} />
              </Route>
              <Route path="/add-document" element={<AddDcoument />} />
              <Route path="/edit-document" element={<EditDocument />} />
              <Route path="/sign-document" element={<RetrieveDocument />} />
              <Route element={<Container/>}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/team" element={<Team />} />
              </Route>
            </Routes>
          </DndProvider>
        </Suspense>
      </Router>
    </div>
  );
};

export default App;
